var _path, _path2, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.55 5.93a1 1 0 0 1 1.9 0l.5 1.56a1 1 0 0 0 .96.7h1.65a1 1 0 0 1 .58 1.8l-1.33.97a1 1 0 0 0-.36 1.12l.5 1.56a1 1 0 0 1-1.53 1.12l-1.33-.97a1 1 0 0 0-1.18 0l-1.33.97a1 1 0 0 1-1.54-1.12l.51-1.56a1 1 0 0 0-.36-1.12l-1.33-.97a1 1 0 0 1 .58-1.8h1.65a1 1 0 0 0 .95-.7l.5-1.56ZM152.05 36.93a1 1 0 0 1 1.9 0l.4 1.22a1 1 0 0 0 .95.69h1.28a1 1 0 0 1 .59 1.8l-1.04.76a1 1 0 0 0-.36 1.12l.4 1.22a1 1 0 0 1-1.54 1.11l-1.04-.75a1 1 0 0 0-1.18 0l-1.03.75a1 1 0 0 1-1.54-1.11l.4-1.22a1 1 0 0 0-.37-1.12l-1.04-.75a1 1 0 0 1 .59-1.81h1.28a1 1 0 0 0 .95-.7l.4-1.21ZM174.05 16.93a1 1 0 0 1 1.9 0l.85 2.6a1 1 0 0 0 .95.69h2.73a1 1 0 0 1 .59 1.8l-2.21 1.62a1 1 0 0 0-.37 1.11l.85 2.6a1 1 0 0 1-1.54 1.12l-2.21-1.6a1 1 0 0 0-1.18 0l-2.21 1.6a1 1 0 0 1-1.54-1.12l.85-2.6a1 1 0 0 0-.37-1.11l-2.21-1.61a1 1 0 0 1 .59-1.81h2.73a1 1 0 0 0 .95-.7l.85-2.6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.6 62.77a45.5 45.5 0 0 1-65.22-60.54 45.5 45.5 0 1 0 65.22 60.54Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 22.5,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 5,
    height: 16,
    rx: 2.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 4,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(30 62 4)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 65,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(30 27 65)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 69,
    width: 5,
    height: 16,
    rx: 2.5,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 67.5,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-30 54 67.5)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6.5,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-30 19 6.5)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23.33,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-60 4 23.33)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-90 0 45)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 45,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-90 69 45)",
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 31.33,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-120 66.5 31.33)",
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 66.33,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-120 6.5 66.33)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 58.33,
    width: 5,
    height: 16,
    rx: 2.5,
    transform: "rotate(-60 65 58.33)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon);
export default __webpack_public_path__ + "static/media/theme-icon.c7f038050f410a079e3ffd7970aa8df2.svg";
export { ForwardRef as ReactComponent };